import { render, staticRenderFns } from "./hotelCard.vue?vue&type=template&id=14666430"
import script from "./hotelCard.vue?vue&type=script&lang=js"
export * from "./hotelCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports